import { useState, useEffect } from 'react';

/**
 * Delays updating the returned value until the input value
 * has stopped changing for the specified delay (ms).
 *
 * @param {*}      value - The value to debounce
 * @param {number} delay - Debounce delay in milliseconds (default: 500ms)
 * @returns The debounced value
 */
const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
